import React from 'react';

export default class LineTable extends React.Component {
  // constructor(props) {
  //     super(props);
  // }

  render() {
    return (
      <table className="table table-sm alt-lines-table">
        <thead>
          <tr>
            <th className="border-0" />
            <th className="small border-0 pr-0">Text</th>
            {this.props.uiToggles.syllables && (
              <th className="small border-0 pr-0" title="Num. Syllables">
                Sybl.
              </th>
            )}
            {this.props.uiToggles.stresses && (
              <th className="small border-0 pr-0" title="Num. Stresses">
                Strs.
              </th>
            )}
            <th className="small border-0" />
          </tr>
        </thead>
        <tbody>{this.props.children}</tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LineTable.js